import { BackendService } from '../BackendService';
import { IRpcService } from '../RpcService';
import {
	IEntitySearchService,
	IPlayerSearchResult,
} from './entitySearchServiceTypes';

export class EntitySearchService implements IEntitySearchService {
	constructor(
		private readonly backend: BackendService,
		private readonly rpc: IRpcService,
	) {}

	public async findOnlinePlayerByNickname(
		nickname: string,
	): Promise<IPlayerSearchResult[]> {
		const result = await this.backend.invoke('characters:search', {
			nickname,
		});

		return result as IPlayerSearchResult[];
	}

	public async findNearbyPlayers(
		radius?: number,
	): Promise<IPlayerSearchResult[]> {
		const result = await this.rpc.invokeClient('game:findNearbyPlayers', {
			radius,
		});

		return result as IPlayerSearchResult[];
	}

	public async findPlayerNicknameByCharacterId(
		characterId: string,
	): Promise<string | null> {
		const result = await this.backend.invoke(
			'game:findPlayerNicknameByCharacterId',
			{
				characterId,
			},
		);

		return result as string | null;
	}
}
